export default __webpack_public_path__ + "ab377fb16d07017d926646a40c5cdd3d.woff2";